import { Component, ViewChild } from "@angular/core";
import { ModalController, NavController, IonTabs } from "@ionic/angular";

import { NewOfferPage } from "../pages/offers/new/new-offer/new-offer.page";
import { Router } from "@angular/router";
import { ActionSheetController, ToastController } from "@ionic/angular";
import { AppSettings } from "../app-settings";

@Component({
  selector: "app-tabs",
  templateUrl: "tabs.page.html",
  styleUrls: ["tabs.page.scss"],
})
export class TabsPage {
  public isWeb: boolean;

  @ViewChild("navTabs") navTabs: IonTabs;

  constructor(
    public modalCtrl: ModalController,
    private navCtrl: NavController,
    private router: Router,
    private actionSheetController: ActionSheetController,
    private toastCtrl: ToastController
  ) {
    this.isWeb = AppSettings.IS_WEB;
  }

  public async chooseNewOfferType() {
    /* WTB/RFQ/OT/WTS */

    if (!this.isWeb) {
      const actionSheet = await this.actionSheetController.create({
        header: "New Post",
        buttons: [
          {
            text: "WTB Network",
            handler: () => {
              this.handleModalShow("WTB", "NETWORK");
            },
          },
          {
            text: "RFQ Network",
            handler: () => {
              this.handleModalShow("RFQ", "NETWORK");
            },
          },
          {
            text: "WTS Network",
            handler: () => {
              this.handleModalShow("WTS", "NETWORK");
            },
          },
          {
            text: "WTB Server",
            handler: () => {
              this.handleModalShow("WTB", "SERVER");
            },
          },
          {
            text: "RFQ Server",
            handler: () => {
              this.handleModalShow("RFQ", "SERVER");
            },
          },
          {
            text: "WTS Server",
            handler: () => {
              this.handleModalShow("WTS", "SERVER");
            },
          },
          {
            text: "Cancel",
            icon: "close",
            role: "cancel",
            handler: () => {},
          },
        ],
      });
      await actionSheet.present();
    }
  }

  //Pop the view if on the change password or company page, else redirect to profile page
  public async handleModalShow(type = "", mailing = null) {
    let modalPage = await this.modalCtrl.create({
      component: NewOfferPage,
      componentProps: {
        transactionType: type,
        transactionMailing: mailing,
      },
    });
    return await modalPage.present();
  }
  public async disabledAction() {
    let toast = await this.toastCtrl.create({
      message:
        "The creation of this transaction is not available at the moment. Consider contacting an administrator for this feature.",
      color: "warning",
      duration: 5000,
      showCloseButton: true,
    });
    toast.present();
  }
  public goToProfile() {
    setTimeout(() => {
      if (
        this.router.url.split("/")[this.router.url.split("/").length - 1] ==
          "company" ||
        this.router.url.split("/")[this.router.url.split("/").length - 1] ==
          "password"
      ) {
        this.navCtrl.pop();
      } else {
        this.navCtrl.navigateRoot("tabs/tab4");
      }
    }, 0);
  }
}
